import $ from 'jquery';
import Backbone from 'backbone';

export default Backbone.View.extend({
  selectors: {
    hiddenClass: 'is-hidden'
  },

  initialize: function() {
    this.$preloader = $('<span class="svg-preloader js-remote-validation" />');
  },

  show: function() {
    this.$el.parent().prepend(this.$preloader);
    this.$el
      .siblings('.icon-invalid-field, .icon-filled-field')
      .addClass(this.selectors.hiddenClass);
  },

  hide: function() {
    this.$preloader.remove();
    this.$el.hasClass('is-invalidate')
      ? this.$el
          .siblings('.icon-invalid-field')
          .removeClass(this.selectors.hiddenClass)
      : this.$el
          .siblings('.icon-filled-field')
          .removeClass(this.selectors.hiddenClass);
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/validation/remotePreloaderView.js
 **/